export enum SubscriptionPricingFormFields {
  Pricing = 'pricing',
  TransferAllEligibleMemberships = 'transferAllEligibleMemberships',
}
